import SlimSelect from 'slim-select';

export function initSlimSelects(className, settings = {}, events = {}) {
  const instances = [];

  document.querySelectorAll(`.${className}`).forEach((el) => {

    const updatePlaceholderClass = () => {
      const ssSingle = el.nextElementSibling?.querySelector('.ss-single');

      if (!ssSingle) return;

      if (el.value === '') {
        ssSingle.classList.add('has-placeholder');
      } else {
        ssSingle.classList.remove('has-placeholder');
      }
    };

    // Find the closest outer wrapper for this select
    const outer = el.closest('.custom-select-outer') || el.parentElement;

    const slim = new SlimSelect({
      select: el,
      settings: {
        showSearch: false,
        contentLocation: outer,
        modal: "off",
        openPosition: "auto",
        contentPosition: "absolute",
        closeOnSelect: true,
        ...settings
      },
      events: {
        afterChange() {
          updatePlaceholderClass();

          // Call user's afterChange if provided
          if (typeof events.afterChange === 'function') {
            events.afterChange(...arguments);
          }
        }
      }
    });

    // Initial state
    setTimeout(updatePlaceholderClass, 0);

    instances.push(slim);
  });

  return instances;
}

document.addEventListener('DOMContentLoaded', () => {
  initSlimSelects('custom-select');
});